import { secondaryPackagingRequest } from '@/request'
interface funResult {
	code?: number;
	data?: any;
	message?: any;
}
//获取平台信息
export const platformInfo = (): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/platform/info',
    isLoading: false,
    needToken: true
})
//修改平台信息
export const platformUpdate = (data:any): Promise<funResult> => secondaryPackagingRequest({
    url: '/sys/platform/update',
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    data,
    isLoading: true,
    needToken: true
})